export default __webpack_public_path__ + "static/media/USAstudent.6e2600e5.jpg";